module.exports = __webpack_public_path__ + "media/entities/1404-33dae66e.png";